import React from 'react';
import * as S from './style';

const TablePanel = props => {
  return <S.TablePanel {...props} />;
};

export { TablePanel };
